import React, { FC } from 'react'
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts'

interface IBarChartComponentProps {
  data: {
    name: string
    value: number
    fill: string
  }[]
  format: 'percentage' | 'values' // Parâmetro para escolher o format
}

const BarChartComponent: FC<IBarChartComponentProps> = ({ data, format = 'percentage' }) => {
  // Calcula o total para obter a porcentagem
  const total = data.reduce((sum, item) => sum + item.value, 0)

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0].payload
      let displayValue: string

      // Verifica o format desejado
      if (format === 'percentage') {
        displayValue = ((value / total) * 100).toFixed(2) + '%'
      } else {
        displayValue = value.toString()
      }

      return (
        <div style={{ background: 'white', padding: 8, border: '1px solid #ccc', borderRadius: 4 }}>
          <p>{name}: {displayValue}</p>
        </div>
      )
    }
    return null
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <RechartsBarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Bar dataKey="value">
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill} />
          ))}
        </Bar>
      </RechartsBarChart>
    </ResponsiveContainer>
  )
}

export { BarChartComponent }
